/* eslint-disable default-param-last */
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import firebase from "src/Firebase";
import moment from "moment";

const db = firebase.firestore();

export const getUsuarios = (idConjunto, observer) =>
  db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "==", idConjunto)
    .where("Roles.residente", "==", true)
    .onSnapshot(observer);
export const updateUsuario = (idUser, data) =>
  db.collection("usuarios").doc(idUser).update({
    Familia: data,
  });

export const ListaResidentes = (idConjunto, Cedula) =>
  db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "==", idConjunto)
    .where("Cedula", "==", Cedula)
    .limit(1)
    .get();

export const updateVisitaAnticipada = (path) =>
  db.doc(path).update({
    EstadoSalida: true,
  });

export const getVisitaAnticipadaWithAditionals = async (
  conjuntoID,
  aditionals = [],
  Cedula
) => {
  const endDay = moment().endOf("day").toDate();
  const startDay = moment().startOf("day").toDate();
  const visitasColl = (id) =>
    db
      .collection("conjuntos")
      .doc(id)
      .collection("visitasAnticipadas")
      .where("Cedula", "==", Cedula)
      .orderBy("HoraEstimadaLlegada")
      .where("HoraEstimadaLlegada", "<=", endDay)
      .where("HoraEstimadaLlegada", ">=", startDay)
      .limit(1);
  const relacionados = aditionals.filter((id) => id !== conjuntoID);
  relacionados.push(conjuntoID);
  const results = await Promise.all(
    relacionados.map((id) => visitasColl(id).get())
  );
  const data = [];
  results.forEach((res) => {
    data.push(...res.docs);
  });
  return data;
};

export const getUsuariosByConjunto = (
  conjuntoID,
  aditionals = [],
  observer
) => {
  const relacionados = aditionals.filter((id) => id !== conjuntoID);
  relacionados.push(conjuntoID);
  return db
    .collection("usuarios")
    .where("ConjuntoUidResidencia", "in", relacionados)
    .where("Roles.residente", "==", true)
    .onSnapshot(observer);
};

export const ListaBlancaNega = async (idConjunto, Cedula) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("lista")
    .where("Cedula", "==", Cedula)
    .limit(1)
    .get();

export const getUser = (usuario) =>
  db.collection("usuarios").doc(usuario).get();

export const getListaWithAditionals = async (
  idConjunto,
  aditionals = [],
  Cedula
) => {
  const listaRef = (id) =>
    db
      .collection("conjuntos")
      .doc(id)
      .collection("lista")
      .where("Cedula", "==", Cedula)
      .limit(1);
  const relacionados = aditionals.filter((id) => id !== idConjunto);
  relacionados.push(idConjunto);
  const results = await Promise.all(
    relacionados.map((id) => listaRef(id).get())
  );
  const data = [];
  results.forEach((res) => {
    data.push(...res.docs);
  });
  return data;
};

export const getUnidadesHabWithAditionals = async (
  conjuntoID,
  aditionals = []
) => {
  const unitsRef = (id) =>
    db.collection("conjuntos").doc(id).collection("unidadesHabitacionales");
  const relacionados = aditionals.filter((id) => id !== conjuntoID);
  relacionados.push(conjuntoID);
  const results = await Promise.all(
    relacionados.map((id) => unitsRef(id).get())
  );
  const data = [];
  results.forEach((res) => {
    data.push(...res.docs);
  });
  return data;
};

export const getUsuario = (observer, idUser) =>
  db.collection("usuarios").doc(idUser).onSnapshot(observer);
export const getModulos = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Modulos")
    .onSnapshot(observer);
export const TiposVisita = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("TiposVisita")
    .onSnapshot(observer);

export const getParkey = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .onSnapshot(observer);

export const updateParkey = (idConjunto, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .update(data);
export const newIngreso = (Conjunto, data) =>
  db.collection("conjuntos").doc(Conjunto).collection("ingresos").add(data);
export const getConjuntoComprobante = (observer, Conjunto) =>
  db.collection("conjuntos").doc(Conjunto).onSnapshot(observer);

export const updateComprobanteTransaccion = (conjuntoUid, data) =>
  db.collection("conjuntos").doc(conjuntoUid).update({
    NumeroComprobante: data,
  });

export const getRubros = (observer, conjuntoUid, tipo) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("rubros")
    .where("Tipo", "==", tipo)
    .onSnapshot(observer);
export const updateIngresoCobros = (conjuntoId, ingresoId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("ingresos")
    .doc(ingresoId)
    .update({
      Cobros: data,
    });

export const addAuthorizedResident = (conjuntoId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .collection("autorizados")
    .add(data);

export const getAuthorizedResidents = async (conjuntoId) => {
  const authorizedCollection = await db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .collection("autorizados")
    .get();

  const authorizedList = authorizedCollection.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return authorizedList;
};

// Función para actualizar un residente autorizado
export const updateAuthorizedResident = (conjuntoId, residentId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .collection("autorizados")
    .doc(residentId)
    .update(data);

// Función para eliminar un residente autorizado
export const deleteAuthorizedResident = (conjuntoId, residentId) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .collection("autorizados")
    .doc(residentId)
    .delete();
